export const initViewValuesBranch = {
  currentIndex: 0,
  bg: { background_0201: 'color', background_0202: 'color' },
  bgImage: {
    background_0201: ['https://image.inappmessage.com/sample/undefined.png'],
    logo_0201: [
      'https://image.inappmessage.com/sample/rating_answer_survey_01.png'
    ],

    background_0202: ['https://image.inappmessage.com/sample/undefined.png'],
    logo_0202: [
      'https://image.inappmessage.com/sample/rating_answer_survey_01.png'
    ],

    background_0301: ['https://image.inappmessage.com/sample/undefined.png'],
    logo_0301: [
      'https://image.inappmessage.com/sample/rating_answer_survey_01.png'
    ]
  },
  bgColor: {
    close_0201: ['#000000'],
    background_0201: ['#ffffff'],

    close_0202: ['#000000'],
    background_0202: ['#ffffff'],

    close_0301: ['#000000'],
    background_0301: ['#ffffff']
  },
  radius: {
    selected_option_button_0201: 30,
    option_button_0201: 30,
    button_0201: 0,

    cta_button_0202: 8,
    button_0202: 0,

    text_area_0301: 8,
    button_0301: 0
  },
  deeplink: {
    cta_button_0202: ['https://www.inappmessage.com/']
  },

  text: {
    title_0201: ['메트릭의 어떠한 점이\n불편하셨나요?'],
    sub_title_0201: [
      '고객님들의 남겨주시는 소중한 의견을 통해\n더 나은 서비스를 제공할 수 있도록\n개선하도록 하겠습니다.'
    ],

    title_0202: ['소중한 답변 감사드립니다\n앱스토어에 리뷰 작성어때요?'],
    sub_title_0202: [
      '고객님들의 남겨주시는 소중한 의견을 통해\n더 나은 서비스를 제공할 수 있도록\n개선하도록 하겠습니다.'
    ],

    title_0301: ['메트릭에 남기고 싶은 말이\n있다면 작성해주세요'],
    sub_title_0301: [
      '고객님들의 남겨주시는 소중한 의견을 통해\n더 나은 서비스를 제공할 수 있도록\n개선하도록 하겠습니다.'
    ]
  },
  fontSize: {
    title_0201: 1.25,
    sub_title_0201: 0.75,

    title_0202: 1.25,
    sub_title_0202: 0.75,

    title_0301: 1.25,
    sub_title_0301: 0.75
  },
  fontWeight: {
    title_0201: 700,
    sub_title_0201: 400,

    title_0202: 700,
    sub_title_0202: 400,

    title_0301: 700,
    sub_title_0301: 400
  },
  color: {
    title_0201: '#000000',
    sub_title_0201: '#828282',

    title_0202: '#000000',
    sub_title_0202: '#828282',

    title_0301: '#000000',
    sub_title_0301: '#828282'
  },
  fontFamily: {
    title_0201: 'Montserrat',
    sub_title_0201: 'Montserrat',

    title_0202: 'Montserrat',
    sub_title_0202: 'Montserrat',

    title_0301: 'Montserrat',
    sub_title_0301: 'Montserrat'
  },
  textAlign: {
    title_0201: 'center',
    sub_title_0201: 'center',

    title_0202: 'center',
    sub_title_0202: 'center',

    title_0301: 'center',
    sub_title_0301: 'center'
  },

  btnText: {
    option_button_0201: [
      [
        '원하는 상품이 없어요',
        '앱 사용이 불편해요',
        '알림이 너무 많이 와요',
        '배송이 너무 느려요',
        '탈퇴하고 싶어요'
        // '설명이 불친절해요',
        // '원하는 상품이 없어요'
      ]
    ],
    button_0201: ['다음으로'],

    cta_button_0202: ['앱스토어에 리뷰 작성하러 가기'],
    button_0202: ['다음으로'],

    text_area_0301: ['메트릭에 남기고 싶은 말이 있다면 작성 부탁드려요.'],
    button_0301: ['다음으로']
  },
  btnFontSize: {
    selected_option_button_0201: 0.75,
    option_button_0201: 0.75,
    selected_button_0201: 0.875,
    button_0201: 0.875,

    cta_button_0202: 0.875,
    selected_button_0202: 0.875,
    button_0202: 0.875,

    text_area_0301: 0.75,
    selected_button_0301: 0.875,
    button_0301: 0.875
  },
  btnFontWeight: {
    selected_option_button_0201: 600,
    option_button_0201: 600,
    selected_button_0201: 600,
    button_0201: 600,

    cta_button_0202: 600,
    selected_button_0202: 600,
    button_0202: 600,

    text_area_0301: 400,
    selected_button_0301: 600,
    button_0301: 600
  },
  btnColor: {
    selected_option_button_0201: '#ffffff',
    option_button_0201: '#828282',
    selected_button_0201: '#000000',
    button_0201: '#999999',

    cta_button_0202: '#ffffff',
    selected_button_0202: '#000000',
    button_0202: '#999999',

    text_area_0301: '#bdbdbd',
    selected_button_0301: '#000000',
    button_0301: '#999999'
  },
  btnBgColorR: {
    selected_option_button_0201: 51,
    option_button_0201: 242,
    selected_button_0201: 255,
    button_0201: 242,

    cta_button_0202: 51,
    selected_button_0202: 255,
    button_0202: 242,

    text_area_0301: 243,
    selected_button_0301: 255,
    button_0301: 242
  },
  btnBgColorG: {
    selected_option_button_0201: 51,
    option_button_0201: 242,
    selected_button_0201: 255,
    button_0201: 242,

    cta_button_0202: 51,
    selected_button_0202: 255,
    button_0202: 242,

    text_area_0301: 243,
    selected_button_0301: 255,
    button_0301: 242
  },
  btnBgColorB: {
    selected_option_button_0201: 51,
    option_button_0201: 242,
    selected_button_0201: 255,
    button_0201: 242,

    cta_button_0202: 51,
    selected_button_0202: 255,
    button_0202: 242,

    text_area_0301: 243,
    selected_button_0301: 255,
    button_0301: 242
  },
  btnBgColorA: {
    selected_option_button_0201: 1,
    option_button_0201: 1,
    selected_button_0201: 1,
    button_0201: 1,

    cta_button_0202: 1,
    selected_button_0202: 1,
    button_0202: 1,

    text_area_0301: 1,
    selected_button_0301: 1,
    button_0301: 1
  },
  btnFontFamily: {
    selected_option_button_0201: 'Montserrat',
    option_button_0201: 'Montserrat',
    selected_button_0201: 'Montserrat',
    button_0201: 'Montserrat',

    cta_button_0202: 'Montserrat',
    selected_button_0202: 'Montserrat',
    button_0202: 'Montserrat',

    text_area_0301: 'Montserrat',
    selected_button_0301: 'Montserrat',
    button_0301: 'Montserrat'
  }
};

export const initTrackingValuesBranch = {
  tracking: {
    close_0201: ['close button 2-1'],
    option_button_0201: [
      [
        'option 2-1-1',
        'option 2-1-2',
        'option 2-1-3',
        'option 2-1-4',
        'option 2-1-5'
      ]
    ],
    button_0201: ['submit button 2-1'],

    close_0202: ['close button 2-2'],
    cta_button_0202: ['cta button 2-2'],
    button_0202: ['submit button 2-2'],

    close_0301: ['close button 3-1'],
    text_area_0301: ['textarea 3-1'],
    button_0301: ['submit button 3-1']
  },
  logCustom: {
    type_0201: [['none', 'none', 'none', 'none', 'none', 'none', 'none']],
    option_button_0201: [
      [
        'log_name',
        'log_name',
        'log_name',
        'log_name',
        'log_name',
        'log_name',
        'log_name'
      ]
    ]
  }
};

export const initEditorValuesBranch = {
  contents_0201: {
    bgImageType: ['logo_0201', 'background_0201'],
    bgColorType: ['close_0201', 'background_0201'],
    bg: ['background_0201'],
    bgImage: ['logo_0201'],
    bgColor: ['close_0201'],

    textType: ['title_0201', 'sub_title_0201'],
    text: ['title_0201', 'sub_title_0201'],
    fontSize: ['title_0201', 'sub_title_0201'],
    fontWeight: ['title_0201', 'sub_title_0201'],
    color: ['title_0201', 'sub_title_0201'],
    fontFamily: ['title_0201', 'sub_title_0201'],
    textAlign: ['title_0201', 'sub_title_0201']
  },
  buttons_0201: {
    branchType: true,
    btnType: [
      'selected_option_button_0201',
      'option_button_0201',
      'selected_button_0201',
      'button_0201'
    ],
    optionText: ['option_button_0201'],
    btnText: [undefined, undefined, undefined, 'button_0201'],
    btnFontSize: [
      'selected_option_button_0201',
      'option_button_0201',
      'selected_button_0201',
      'button_0201'
    ],
    btnFontWeight: [
      'selected_option_button_0201',
      'option_button_0201',
      'selected_button_0201',
      'button_0201'
    ],
    btnColor: [
      'selected_option_button_0201',
      'option_button_0201',
      'selected_button_0201',
      'button_0201'
    ],
    btnBgColor: [
      'selected_option_button_0201',
      'option_button_0201',
      'selected_button_0201',
      'button_0201'
    ],
    btnFontFamily: [
      'selected_option_button_0201',
      'option_button_0201',
      'selected_button_0201',
      'button_0201'
    ],
    radius: [
      'selected_option_button_0201',
      'option_button_0201',
      undefined,
      'button_0201'
    ],
    radiusMax: [30, 30, undefined, 30]
  },
  trackings_0201: {
    trackingType: ['close_0201', 'option_button_0201', 'button_0201'],
    logCustomType: ['type_0201', 'option_button_0201']
  },

  contents_0202: {
    bgImageType: ['logo_0202', 'background_0202'],
    bgColorType: ['close_0202', 'background_0202'],
    bg: ['background_0202'],
    bgImage: ['logo_0202'],
    bgColor: ['close_0202'],

    textType: ['title_0202', 'sub_title_0202'],
    text: ['title_0202', 'sub_title_0202'],
    fontSize: ['title_0202', 'sub_title_0202'],
    fontWeight: ['title_0202', 'sub_title_0202'],
    color: ['title_0202', 'sub_title_0202'],
    fontFamily: ['title_0202', 'sub_title_0202'],
    textAlign: ['title_0202', 'sub_title_0202']
  },
  buttons_0202: {
    branchType: true,
    btnType: ['cta_button_0202', 'selected_button_0202', 'button_0202'],
    btnText: ['cta_button_0202', undefined, 'button_0202'],
    btnFontSize: ['cta_button_0202', 'selected_button_0202', 'button_0202'],
    btnFontWeight: ['cta_button_0202', 'selected_button_0202', 'button_0202'],
    btnColor: ['cta_button_0202', 'selected_button_0202', 'button_0202'],
    btnBgColor: ['cta_button_0202', 'selected_button_0202', 'button_0202'],
    btnFontFamily: ['cta_button_0202', 'selected_button_0202', 'button_0202'],
    deeplink: ['cta_button_0202', undefined, undefined],
    radius: ['cta_button_0202', undefined, 'button_0202'],
    radiusMax: [30, 30]
  },
  trackings_0202: {
    trackingType: ['close_0202', 'cta_button_0202', 'button_0202']
  },

  contents_0301: {
    bgImageType: ['logo_0301', 'background_0301'],
    bgColorType: ['close_0301', 'background_0301'],
    bg: ['background_0301'],
    bgImage: ['logo_0301'],
    bgColor: ['close_0301'],

    textType: ['title_0301', 'sub_title_0301'],
    text: ['title_0301', 'sub_title_0301'],
    fontSize: ['title_0301', 'sub_title_0301'],
    fontWeight: ['title_0301', 'sub_title_0301'],
    color: ['title_0301', 'sub_title_0301'],
    fontFamily: ['title_0301', 'sub_title_0301'],
    textAlign: ['title_0301', 'sub_title_0301']
  },
  buttons_0301: {
    branchType: true,
    btnType: ['text_area_0301', 'selected_button_0301', 'button_0301'],
    btnText: ['text_area_0301', undefined, 'button_0301'],
    btnFontSize: ['text_area_0301', 'selected_button_0301', 'button_0301'],
    btnFontWeight: ['text_area_0301', 'selected_button_0301', 'button_0301'],
    btnColor: ['text_area_0301', 'selected_button_0301', 'button_0301'],
    btnBgColor: ['text_area_0301', 'selected_button_0301', 'button_0301'],
    btnFontFamily: ['text_area_0301', 'selected_button_0301', 'button_0301'],
    radius: ['text_area_0301', undefined, 'button_0301'],
    radiusMax: [30, undefined, 30]
  },
  trackings_0301: {
    trackingType: ['close_0301', 'text_area_0301', 'button_0301']
  }
};
